module.exports = __webpack_public_path__ + "static/media/hushdream-5.13a86749.jpg";